import React from "react";
import { Link } from "react-router-dom";
import styled, { css } from "styled-components";
import { buttonResetStyles } from "../../utils";

const sharedStyles = css`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    color: white;
    width: 66px;
    margin-left: -10px;
    margin-right: -10px;
    height: 46px;
    text-decoration: none;
`;

const WrapperButton = styled.button`
    ${buttonResetStyles};
    ${sharedStyles};
`;

const WrapperLink = styled(Link)`
    ${sharedStyles};
`;

const Text = styled.div`
    font-size: 14px;
    font-weight: 500;
    margin-top: 4px;
`;

const Badge = styled.div`
    position: absolute;
    top: 0px;
    right: 17px;
    background-color: #ff646b;
    width: 12px;
    height: 12px;
    border-radius: 50%;
`;

interface IconActionProps {
    icon: React.ReactNode;
    children: string;
    onClick?: () => void;
    to?: string;
    showBadge?: boolean;
}

export const IconAction = (props: IconActionProps) => {
    const inner = (
        <>
            {props.showBadge && <Badge />}
            {props.icon}
            <Text>{props.children}</Text>
        </>
    );

    if (props.to) {
        return (
            <WrapperLink to={props.to} onClick={props.onClick}>
                {inner}
            </WrapperLink>
        );
    }
    return <WrapperButton onClick={props.onClick}>{inner}</WrapperButton>;
};
